import React from "react";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import useGetEmployeesWithTerminatedSupervisors from "./hooks/useGetEmployeesWithTerminatedSupervisors";
import { CSVLink } from "react-csv";
import { UsersIcon } from "@heroicons/react/24/solid";
import { useRecoilState, useRecoilValue } from "recoil";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { employeeFromReports } from "../../Employees/Confie/atoms/atoms";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { EmployeeTabs } from "../../../EmployeeTab/EmployeeTab";
import DownloadButton from "../../../../components/DownloadButton";
import { accountAtom } from "../../../Login/atoms/AccountAtom";

interface IEmployeesWithTerminatedSupervisors {
  employeenumber: string;
  fullname: string;
  officeName: string;
  employeeTypeName: string;
  title: string;
  department: string;
  reportsToFullname: string;
  reportstostatus: string;
}
export const EmployeesWithTerminatedSupervisors = () => {
  const {
    data: employeesWithTerminatedSupervisors,
    isLoading: terminatedSupervisoresLoading,
  } = useGetEmployeesWithTerminatedSupervisors();

  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const [, setShowFromReports] = useRecoilState(employeeFromReports);
  const user = useRecoilValue(accountAtom);

  //For downloading table data
  const exportdata = employeesWithTerminatedSupervisors
    ?.filter((x) =>
      user.isFranchise && user.isNonFranchise
        ? x.employeeTypeName !== ""
        : user.isFranchise
        ? x.employeeTypeName?.toLowerCase() === "franchise"
        : x.employeeTypeName?.toLowerCase() !== "franchise"
    )
    ?.map((emp: IEmployeesWithTerminatedSupervisors) => {
      return {
        "Employee ID": '=""' + emp.employeenumber + '""',
        "Full Name": emp.fullname,
        "Office Name": emp.officeName,
        "Employee Type": emp.employeeTypeName,
        Title: emp.title,
        Department: emp.department,
        "Reports To": emp.reportsToFullname,
        "Reports To Status": emp.reportstostatus,
      };
    });
  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  const csvReport = {
    filename: "EmployeesWithTerminatedSupervisors_" + dateTimeToday + ".csv",
    data: exportdata ? exportdata : [],
  };
  const employeeColumns = [
    { title: "Employee ID", field: "employeenumber" },
    {
      title: "Full Name",
      field: "fullname",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/employeetab/employee";
              history.push({
                pathname: url,
                state: {
                  employeeNumber: rowData?.employeeid,
                  action: "EmployeeWithTerminatedSupReports",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...EmployeeTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
              setShowFromReports(true);
            }}
          >
            <span className="text-quinary font-bold underline text-sm ">
              {rowData.fullname}
            </span>
          </div>
        );
      },
    },
    {
      title: "Office Name",
      field: "officeName",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/officesettings/officesetting";
              history.push({
                pathname: url,
                state: {
                  officeCode: rowData?.officecode,
                  action: "WithTerminatedSup",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...OfficeTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
            }}
          >
            <span className="text-quinary font-bold underline text-sm ">
              {rowData.officeName}
            </span>
          </div>
        );
      },
    },
    { title: "Employee Type", field: "employeeTypeName" },
    { title: "Title", field: "title" },
    { title: "Department", field: "department" },
    { title: "Reports To", field: "reportsToFullname" },
    { title: "Reports To Status", field: "reportstostatus" },
  ];

  return (
    <div className="text-xs items-center">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <UsersIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading tight">
              <div className="text-gray-500 text-md font-medium">
                Report: Employees & Offices
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                Employees with Terminated Supervisors
              </div>
            </div>
          </div>
          <div className="mt-2" />
          <div className="flex justify-between">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-primary text-base font-semibold">
                {user.isFranchise && user.isNonFranchise
                  ? employeesWithTerminatedSupervisors?.length
                  : employeesWithTerminatedSupervisors?.filter(
                      (x) =>
                        x.employeenumber !== "" &&
                        (user.isFranchise
                          ? x.employeeTypeName?.toLowerCase() === "franchise"
                          : x.employeeTypeName?.toLowerCase() !== "franchise")
                    ).length}
              </span>
            </div>
            <CSVLink {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() => exportdata}
                className={undefined}
                disabled={undefined}
              />
            </CSVLink>
          </div>
        </div>
        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={
              user.isFranchise && user.isNonFranchise
                ? employeesWithTerminatedSupervisors
                : employeesWithTerminatedSupervisors?.filter(
                    (x) =>
                      x.employeenumber !== "" &&
                      (user.isFranchise
                        ? x.employeeTypeName?.toLowerCase() === "franchise"
                        : x.employeeTypeName?.toLowerCase() !== "franchise")
                  )
            }
            isLoading={terminatedSupervisoresLoading}
            columns={employeeColumns}
            showTitle={false}
          />
        </div>
      </div>
    </div>
  );
};
